import { FileStat } from '@theia/filesystem/lib/common/files';
import { WorkspaceInput, WorkspaceService } from '@theia/workspace/lib/browser/workspace-service';

export class BrowserOnlyWorkspaceService extends WorkspaceService {
    async closeInCurrentWindow(): Promise<void> {
        await this.setWorkspace(undefined);
    }

    protected override openWindow(uri: FileStat, options?: WorkspaceInput): void {
        if (!this.shouldPreserveWindow(options)) {
            super.openWindow(uri, options);
            return;
        }

        void this.setWorkspace(uri).catch((error: unknown) => {
            this.logger.error(`Failed to open workspace in current window: ${String(error)}`);
            super.openWindow(uri, options);
        });
    }
}
